import { render, staticRenderFns } from "./TarifCalculator.vue?vue&type=template&id=8475e842"
import script from "./TarifCalculator.vue?vue&type=script&lang=js"
export * from "./TarifCalculator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports